import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  mapContainer: {
    width: "100%",
    height: `calc(100vh - 65px)`,
  },
}));
